import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import useStyles from '@front10/helpers/dist/UseStyles';
import { Context } from '@front10/helpers/dist/Context';
import Box from '../../elements/Box';

const LocationSelectorMenu = React.forwardRef((props, ref) => {
  const { children, showArrow, flatMode, position, id } = props;
  const { direction, theme } = useContext(Context);
  const [className, style] = useStyles(props, { direction, theme });
  return (
    <Box
      focusReferences={ref}
      id={id}
      className={`${className} location-selector-menu`}
      style={style}
      position={position}
    >
      {showArrow && <span className="location-selector-menu-arrow" />}
      <Box
        className={`location-selector-menu-container ${
          !flatMode ? 'location-selector-menu-container--maxHeight' : ''
        }`}
      >
        {children}
      </Box>
    </Box>
  );
});

LocationSelectorMenu.propTypes = {
  /**
   * Text of the label.
   */
  children: PropTypes.oneOfType([PropTypes.node, PropTypes.arrayOf(PropTypes.node)]),
  /**
   * Show arrow
   */
  showArrow: PropTypes.bool,
  /**
   * Define if component have a max-height
   */
  flatMode: PropTypes.bool,
  position: PropTypes.string,
  id: PropTypes.string
};

LocationSelectorMenu.defaultProps = {
  children: null,
  showArrow: true,
  flatMode: false,
  position: 'absolute',
  id: null
};

export default LocationSelectorMenu;
